<template>
  <mdb-container fluid class="bv-example-row smswrapper">
    <mdb-row class="d-flex justify-content-center center reqsecondrow">
      <mdb-row class="subreqsecondrow">
        <mdb-btn @click.native="showModal = true" color="yellow">
          사실견적신청 <mdb-icon icon="chevron-circle-right" class="ml-1"/>
        </mdb-btn>
        <mdb-modal :show="showModal" @close="showModal = false"
          cascade class="text-left popup">
        <mdb-modal-header class="deep-grey-text header mt-3 mb-4 pb-1 mx-5">
            <h4 class="title"><fa class="fas fa-pencil-alt" /></h4>
        </mdb-modal-header>
        <mdb-modal-body class="black-text">
            <mdb-input
              type="text"
              size="sm"
              label="이름"
              icon="user"
              v-model="sms.name"
              :customValidation="validation.name.validated"
              :isValid="validation.name.valid"
              @change="validate('name')"
              required
              validFeedback=""
              invalidFeedback="이름을 입력하여 주세요."
            />
            <mdb-input
              type="text"
              size="sm"
              label="전화번호"
              icon="mobile-alt"
              @change="validate('phone')"
              :customValidation="validation.phone.validated"
              :isValid="validation.phone.valid"
              v-model="sms.phone"
              validFeedback=""
              invalidFeedback="전화번호는 '0100000000', 010-0000-0000' 형태로 입력하셔야 합니다."
              required
            />
            <mdb-input
              type="text"
              size="sm"
              label="차종"
              icon="car"
              @change="validate('car')"
              :customValidation="validation.car.validated"
              :isValid="validation.car.valid"
              v-model="sms.car"
              validFeedback=""
              invalidFeedback="차명을 입력하세요."
              required
            />
            <mdb-textarea
              size="sm"
              :rows="2"
              label="Your message"
              icon="pencil"
              v-model="sms.message" />
          <mdb-input
              type="checkbox"
              size="sm"
              label="개인정보 처리방침 동의"
              id="privatecheckbox"
              v-model="sms.private"
              @change="validate('private')"
              :customValidation="validation.private.validated"
              :isValid="validation.private.valid"
              required
              validFeedback=""
              invalidFeedback="개인정보 동의해주세요."
            />
        </mdb-modal-body>

        <mdb-modal-footer>
            <mdb-btn class="btnfooter" @click.native="showModal = false" color="yellow">닫기</mdb-btn>
            <mdb-btn class="btnfooter" @click.native="validateForm" color="yellow">신청완료</mdb-btn>
        </mdb-modal-footer>
        </mdb-modal>
      </mdb-row>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbContainer, mdbRow, mdbInput, mdbTextarea, mdbBtn, mdbIcon,
  mdbModal, mdbModalHeader, mdbModalBody, mdbModalFooter,
} from 'mdbvue';
import { sms } from '@/api';

export default {
  name: 'FormsPage',
  components: {
    mdbContainer,
    mdbRow,
    mdbInput,
    mdbTextarea,
    mdbBtn,
    mdbIcon,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
  },
  data() {
    return {
      sms: {
        private: true,
        name: '',
        phone: '',
        car: '',
        message: '',
        smsSendYn: 'N',
      },
      validation: {
        private: {
          valid: true,
          validated: true,
        },
        name: {
          valid: false,
          validated: false,
        },
        phone: {
          valid: false,
          validated: false,
        },
        car: {
          valid: false,
          validated: false,
        },
      },
      showModal: false,
    };
  },
  methods: {
    validate(key) {
      if (key === 'name' || key === 'car' || key === 'private') {
        if (this.sms[key]) {
          this.validation[key].valid = true;
        } else {
          this.validation[key].valid = false;
        }
        this.validation[key].validated = true;
      }
      if (key === 'phone') {
        const repPhone = /^[0-9]{3}-{0,1}[0-9]{3,4}-{0,1}[0-9]{4}$/;
        const isMatch = repPhone.test(this.sms.phone);
        if (isMatch) {
          this.validation[key].valid = true;
        } else {
          this.validation[key].valid = false;
        }
        this.validation[key].validated = true;
      }
    },
    validateForm() {
      let isValid = true;
      let isValidated = true;

      Object.keys(this.validation).forEach((key) => {
        if (!this.validation[key].valid) { isValid = false; }
        if (!this.validation[key].validated) { isValidated = false; }
      });

      if (isValid && isValidated) {
        this.sendSms();
      }
    },
    sendSms() {
      sms.sendSms(this.sms)
        .then()
        .finally(() => {
          this.showModal = false;
          Object.keys(this.sms).forEach((key) => {
            this.sms[key] = '';
            this.validation[key].valid = false;
            this.validation[key].validated = false;
          });
        });
    },
  },
};
</script>

<style scoped>
.modal-dialog.cascading-modal .modal-header {
  padding: 0 0px !important;
  margin: 0 0px;
  text-align: center;
  border: none;
  border-radius: .125rem;
  height: 150px;
  max-width: 100% !important;
}
@media (max-width: 500px){
  .modal-dialog.cascading-modal .modal-header {
  padding: 0 0px !important;
  margin: 0 0px;
  text-align: center;
  border: none;
  border-radius: .125rem;
  height: 150px;
  max-width: 380px !important;
  }
}
.smswrapper {
  background-color: #212121;
  max-width: 1900px;
  max-height: 800px;
  align-items: center;
  margin: 0 0px;
  padding: 0 0px;
}
@media (max-width: 500px){
  .smswrapper {
    background-color: #212121;
    max-width: 380px;
    height: auto;
    align-items: center;
    margin: 0 0px;
  }
}
.header{
  background: url('/static/images/body/smsbg.png') no-repeat center;
  max-width: 450px;
  height: auto;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
}
@media (max-width: 500px){
  .header{
    background: url('/static/images/body/smsbg.png') no-repeat center;
    max-width: 100%;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    margin-top: 10px;
  }
}
.pb-1, .py-1 {
  padding-bottom: 10px !important;
}
.ml-5, .mx-5 {
  margin-left: 10px !important;
}
.mr-5, .mx-5 {
  margin-right: 10px !important;
}
.mb-4, .my-4 {
  margin-bottom: 0px !important;
}
.mt-3, .my-3 {
  margin-top: 0px !important;
}
.reqsecondrow {
  margin: 0px 0px !important;
  max-height: 100% !important;
  background-color: #212121;
}

.subreqsecondrow {
  margin: 0px 0px !important;
  max-height: 100% !important;
  align-items: center;
  margin: 0px 0px !important;
  max-height: 380px !important;
  background-color: white;;
  width: 1348px;
}

.btn-info {
  color: black;
  background-color: #ffba00 !important;
}
.btn-info :hover {
  color: white;
  background-color: #ffba00 !important;
}
.btn-yellow:hover {
  color:cornsilk;
  background-color: #ffba00;
}
.btn-yellow {
  color: cornsilk;
  background-color: #ffba00;
}

.btn {
  margin: 1% auto;
  font-weight: 550;
  text-transform: uppercase;
  word-wrap: break-word;
  white-space: normal;
  cursor: pointer;
  border: 0;
  border-radius: .125rem;
  padding: .94rem 2.24rem;
  font-size: 1.2rem;
  color: black;
}

.btn-yellow:hover {
    color: #fff;
    background-color: #fbc846;
}

.fa, .fas {
  font-weight: 550;
}
.fa, .far, .fas {
  font-family: "Font Awesome 5 Free";
}
.fa, .fab, .fad, .fal, .far, .fas {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
}
.pl-1, .px-1 {
  padding-left: 0px !important;
}
.btnfooter {
  margin-left: 0;
  margin-right: 13%;
}
</style>
